module.exports = __webpack_public_path__ + "/images/ico-share-whatsapp.2be150d.svg";